// Платформа сборки для гейта доступности.
//
// Отдельный модуль, потому что значение нужно и снапшоту (`snapshot.ts`,
// путь первого рендера), и хуку-читателю, и провайдеру-писателю. Держать его
// в хуке значило бы завести цикл `store → hooks → store`.

import type { ModulePlatform } from "@studyhub/shared/module";
import { IS_CAPACITOR } from "@/lib/platform-detect";

/**
 * Платформа этого клиента — факт сборки, известный точно.
 *
 * Сервер вывести его не может: внутри Capacitor WebView User-Agent неотличим
 * от мобильного браузера, и гейт `platform_unsupported` срабатывал бы не там,
 * где нужно. Поэтому платформу передаёт клиент.
 */
export const CLIENT_MODULE_PLATFORM: ModulePlatform = IS_CAPACITOR ? "capacitor" : "web";
